
async function formatSecondsToTime(seconds){
  let time = '0'
  let hours = Math.floor(seconds / 3600)
  let remaining = seconds - (hours * 3600)
  let minutes = Math.round(remaining / 60)
  time = hours + ' h ' + minutes + ' m'
  return time
}


export {
  formatSecondsToTime,
};
